import { Box, Button, Input, Text } from "@chakra-ui/react";
import React from "react";
import { PasswordInput } from "../custom/PasswordInput";
import Form from '../custom/Form'
import Logo from '../../components/brand/Logo'
import { Link } from "react-router-dom";
import { UseFormReturnType } from "@mantine/form";
import { SigninData } from "../../pages/auth/signin";

const style = {
  backgroundColor: '#313338',
  width: '100%', 
  borderRadius: 15,
  paddingTop: 35,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 90,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
}

interface Props {
  handleSignin: (values: SigninData) => void;
  bypassAuth: () => void;
  form: UseFormReturnType<{
    email: string;
    password: string;
  }>,
  isLoading: boolean
}

const SigninForm: React.FC<Props> = ({ handleSignin, form, isLoading, bypassAuth }) => {
  return (
    <Form 
      style={style} 
      onSubmit={form.onSubmit((values) => handleSignin(values))}
    >
      <Box w="100%" px={[3, 10]}>
        <Box 
          textAlign='center' 
          fontWeight='bold' 
          fontSize={['xl']}
        >
          <Logo color='#B5BAC1' />

          <Text color='#B5BAC1' mt={8}>
            Administrator Signin
          </Text>
        </Box>

        <Box mt={5} w="100%">
          <Box>
            <Text fontWeight='semibold' color='#B5BAC1'>
              Email
            </Text>

            <Input 
              {...form.getInputProps('email')}
              disabled={isLoading}
              bgColor='#1E1F22' size='lg' mt={1}
              placeholder="admin@admin.com"  
              _placeholder={{ color: '#B5BAC1' }} 
              color='#B5BAC1' 
              border={form.errors.email ? '2px' : '0px'}
              borderColor={form.errors.email ? 'red.500' : 'transparent'} 
              focusBorderColor={form.errors.email ? 'red.500' : 'transparent'} 
              _hover={{ outlineColor: 'transparent' }} 
            />

            {form.errors.email &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.email}
              </Text>
            }
          </Box>

          <Box mt={5}>
            <Text fontWeight='semibold' color='#B5BAC1'>
              Password
            </Text>

            <PasswordInput 
              disabled={isLoading}
              border={form.errors.password ? '2px' : '0px'}
              borderColor={form.errors.password ? 'red.500' : 'transparent'}
              focusBorderColor={form.errors.password ? 'red.500' : 'transparent'} 
              props={{ ...form.getInputProps('password') }} 
            />

            {form.errors.password &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {form.errors.password}
              </Text>
            }
          </Box>

          <Box style={{ width: "fit-content" }} mt={5}>
            <Link to='/forgot_password'>
              <Text _hover={{ textDecoration: "underline" }} w='fit-content' fontWeight='light' fontSize='sm' color='#B5BAC1'>
                Forgot Password?
              </Text>
            </Link>
          </Box>

          <Box mt={5}>
            <Button 
              isLoading={isLoading}
              type="submit"
              bg='#37A75B' size="lg" 
              w='100%' color='white' 
              _hover={{ backgroundColor: isLoading ? '#37A75B' : '#046425' }}
            >
              Signin
            </Button>
          </Box>

          <Box mt={5}>
            <Button
              isLoading={isLoading}
              type="button"
              onClick={bypassAuth}
              colorScheme='gray' size="lg"
              w='100%' color='#313338'
            >
              Bypass auth
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

export default SigninForm